// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4sMFT","right":"styles_right__eAwHi"};